import { useState, useEffect } from 'react';

export function useDynamicImport(componentPath) {
  const [component, setComponent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Reset du composant à chaque changement de componentPath
    setComponent(null);
    setError(null);
    
    if (!componentPath) {
      setLoading(false);
      return;
    }

    const loadComponent = async () => {
      try {
        setLoading(true);
        
        // Mapping des chemins vers les imports dynamiques
        const componentMap = {
          './Dashboard': () => import('../Dashboard'),
          './parametrage/base/Series': () => import('../parametrage/base/Series'),
          './parametrage/base/Articles': () => import('../parametrage/base/Articles'),
          './parametrage/base/Metiers': () => import('../parametrage/base/Metiers'),
          './parametrage/tables/Poste': () => import('../parametrage/tables/Poste'),
          './parametrage/tables/Modele': () => import('../parametrage/tables/Modele'),
          './parametrage/tables/Famille': () => import('../parametrage/tables/Famille'),
          './parametrage/tables/StatutMetier': () => import('../parametrage/tables/StatutMetier'),
          './parametrage/tables/TypeEvent': () => import('../parametrage/tables/TypeEvent'),
          './parametrage/tables/Intervenant': () => import('../parametrage/tables/Intervenant'),
          './parametrage/tables/Declarant': () => import('../parametrage/tables/Declarant'),
          './parametrage/tables/Imprevu': () => import('../parametrage/tables/Imprevu'),
          './parametrage/tables/Localisation': () => import('../parametrage/tables/Localisation'),
          './parametrage/tables/Qualite': () => import('../parametrage/tables/Qualite'),
          './parametrage/tables/Utilisateur': () => import('../parametrage/tables/Utilisateur'),
          './parametrage/tables/Motifs': () => import('../parametrage/tables/Motifs'),
          './parametrage/acces/index': () => import('../parametrage/acces/index'),
          './parametrage/acces/Profil': () => import('../parametrage/acces/Profil'),
          './parametrage/acces/Droit': () => import('../parametrage/acces/Droit'),
          './parametrage/annuels/ChoixCY': () => import('../parametrage/annuels/ChoixCY'),
          './parametrage/annuels/ParametrageCY': () => import('../parametrage/annuels/ParametrageCY'),
          './parametrage/annuels/Objectifs': () => import('../parametrage/annuels/Objectifs'),
          './etats/production/EtatDuParc': () => import('../etats/production/EtatDuParc'),
          './etats/production/BilanProduction': () => import('../etats/production/BilanProduction'),
          './etats/synthese/AnalyseDetaillee': () => import('../etats/synthese/AnalyseDetaillee'),
          './imports/Plan': () => import('../imports/Plan'),
          './imports/Production': () => import('../imports/Production'),
        };

        const importFunction = componentMap[componentPath];
        
        if (!importFunction) {
          throw new Error(`Composant non trouvé: ${componentPath}`);
        }

        const module = await importFunction();
        setComponent(() => module.default);
      } catch (err) {
        console.error('Erreur lors du chargement du composant:', err);
        setError(err.message);
        setComponent(null);
      } finally {
        setLoading(false);
      }
    };

    loadComponent();
  }, [componentPath]);

  return { component, loading, error };
} 